import dynamic from 'next/dynamic';

import Flex from 'shopper/components/Flex';

import { useTopbar } from 'providers/TopbarProvider';

import Z_INDEX_SCALE from 'constants/zIndexScale';

const TopbarAd = dynamic(() => import('./TopbarAd'));
const TopbarDesktop = dynamic(() => import('./Desktop'));
const TopbarMobile = dynamic(() => import('./Mobile'));

const Topbar = () => {
  const {
    topbarAd,
    topbarDesktop: {
      isTopbarActive: isDesktopTopbarActive,
      isTopbarBottomActive: isDesktopTopbarBottomActive,
    },
    topbarMobile: {
      isSearchActive,
      isTopbarActive: isMobileTopbarActive,
      isTopbarBottomActive: isMobileTopbarBottomActive,
    },
  } = useTopbar();

  if (!isDesktopTopbarActive && !isMobileTopbarActive) {
    return null;
  }

  return (
    <>
      {topbarAd && <TopbarAd />}
      <Flex
        as="header"
        flexDirection="column"
        position="sticky"
        top={0}
        zIndex={Z_INDEX_SCALE.SIZE_4}
        mb={[
          isMobileTopbarBottomActive || isSearchActive ? 10 : null,
          null,
          null,
          isDesktopTopbarBottomActive ? 10 : 0,
        ]}
        full
      >
        {isDesktopTopbarActive && <TopbarDesktop />}
        {isMobileTopbarActive && <TopbarMobile />}
      </Flex>
    </>
  );
};

export default Topbar;
